function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.001 6.018V18c0 1.652-1.347 3-3 3h-16c-1.652 0-3-1.348-3-3V6c0-1.652 1.348-3 3-3h16a3.006 3.006 0 013 3.018zM3.108 5.554C3.273 5.227 3.613 5 4 5h16c.388 0 .728.227.894.554L12 11.78 3.108 5.554zM3 7.921V18c0 .548.453 1 1 1h16c.548 0 1-.452 1-1V7.92l-8.426 5.9a1 1 0 01-1.147 0L3 7.92z",
  fill: "#6E0BD0"
});

function SvgMailinline(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgMailinline;